﻿module Client.ContractPage.PurchaseOrders.Config

open Feliz

let costColor = style.backgroundColor "rgb(239, 239, 227)"
let quantityColor = style.backgroundColor "rgb(235, 235, 235)"
